import React from 'react'
import { Row, Col, Button, Form } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt, faPlusCircle } from '@fortawesome/free-solid-svg-icons'

 const AccountList = ({ action, onAdd, onDelete, onChange, onClose, accountList = [] }) => {
  const subAccountList = accountList.map((value, index, arr) => {
    return (
      <Row className="pb-2" key={index}>
        <Col sm={10} className="pr-2">
          <Form.Control 
              maxLength={10}
              name={"accountNumber"}
              disabled = {true}
              required
              value={value} 
              placeholder={"Enter Account Number"}
              onChange={(e) => onChange(index, e.target.value, "NUMERIC")}  />
        </Col>   
      </Row>
      )
    }
  );

  return (
    <React.Fragment>
      <Row>
          <Col sm={11}>
            <Form.Label className={"text-grey font-weight-bold medium required"}>Bank Account Number</Form.Label>
          </Col>
      </Row>
      {subAccountList}
      <Row className="pt-5">
          <Col sm={{span:3, offset:9}}>
            <Button variant="outline-scb" block onClick={onClose}>Done</Button>
          </Col>
      </Row>
    </React.Fragment>
  );
   
}
export default AccountList